var React = require('react');

function Selected (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21","cy":"21","r":"16","fill":"#004445","key":0}),React.createElement("circle",{"cx":"21","cy":"21","r":"18.5","stroke":"white","strokeOpacity":"0.5","strokeWidth":"5","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.8935 26.9996L27.9999 17.8933L26.5857 16.4791L18.8933 24.1715L15.4142 20.6924L14 22.1066L18.893 26.9997L18.8933 26.9994L18.8935 26.9996Z","fill":"white","key":2})]);
}

Selected.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Selected;

Selected.default = Selected;
